function slugify(value: string) {
  const normalized = value
    .toLowerCase()
    .normalize("NFKD")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
  return normalized;
}

export function buildEventPath(id: string, title?: string | null) {
  const slugSource = title?.trim() || "event";
  const slug = slugify(slugSource) || "event";
  return `/${id}/${slug}`;
}
